import {parseWkt} from "../../../../js/wkt-utils";
import {Feature} from "ol";
import {Cluster} from "./cluster";
import {Point} from "./point";
import {Announcement} from "./announcement";
import {formatMoney} from "../../../../js/formatters";

export const pointToFeature = (commonPoint: Cluster | Point | Announcement): Feature => {
  if (commonPoint.type === 'cluster') {
    const cluster = commonPoint as Cluster;
    const center = parseWkt(cluster.center_wkt);

    const feature = new Feature({
      geometry: center!,
      envelopeWkt: cluster.envelope_wkt
    });

    feature.set("type", cluster.type);
    feature.set("center_wkt", cluster.center_wkt);
    feature.set("event_occurrences_count", cluster.event_occurrences_count);
    feature.set("colors", cluster.colors);

    return feature;
  } else if (commonPoint.type === 'point') {
    const point = commonPoint as Point;
    const geometry = parseWkt(point.coords)
    if (!geometry) { throw new Error(`Incorrect Wkt format ${point.coords}`); }

    const feature = new Feature({
      geometry: geometry
    });

    feature.set("type", point.type);
    feature.set("event_occurrence_ids", point.event_occurrence_ids);
    feature.set("event_occurrences_count", point.event_occurrences_count);
    feature.set("colors", point.colors);

    return feature;
  } else if (commonPoint.type === 'announcement') {
    const announcement = commonPoint as Announcement;
    const geometry = parseWkt(announcement.coords)
    if (!geometry) { throw new Error(`Incorrect Wkt format ${announcement.coords}`); }

    const feature = new Feature({
      geometry: geometry
    });

    feature.set("type", announcement.type);
    feature.set("id", announcement.id);
    feature.set("title", announcement.title);
    feature.set("text", announcement.text);
    feature.set("advertising_thumb_url", announcement.advertising_thumb_url);
    feature.set("price", formatMoney(announcement.price));
    feature.set("urgent", announcement.urgent);

    return feature;
  } else {
    throw new Error(`Unknown point type ${JSON.stringify(commonPoint)}`);
  }
}